module.exports = __webpack_public_path__ + "img/20220310_150844.da0d695e.jpg";